        <registration-description id="questioner"
                                  [serviceId]="serviceId"
                                  [registration]="registration"
                                  [showCancelButton]="true"
                                  (modalClosedEvent)="closeModal($event)">
        </registration-description>
        <registration-determinant id="registration"
                                  [smallView]="true"
                                  [serviceId]="serviceId"
                                  [registration]="registration"
                                  [determinantMapById]="determinantMapById"
                                  (modalClosedEvent)="closeModal($event)"></registration-determinant>
